import { render, staticRenderFns } from "./VenueCampaignStats.vue?vue&type=template&id=3da62278&scoped=true&"
import script from "./VenueCampaignStats.vue?vue&type=script&lang=js&"
export * from "./VenueCampaignStats.vue?vue&type=script&lang=js&"
import style0 from "./VenueCampaignStats.vue?vue&type=style&index=0&id=3da62278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da62278",
  null
  
)

export default component.exports